import { CurrentUserService } from '../services';

export default class SetNewPasswordInteractor {
  service: CurrentUserService;

  constructor( { service = new CurrentUserService() } = {} ) {
    this.service = service;
  }

  execute( token: string, password: string ) {
    return this.service.setNewPassword( token, password );
  }
}
